import ARRANGEMENT from 'src/api/dev/arrangement'
import * as T from './types'

const module = {
    state: {
        list: [],
        total: 0,
        relationList: []
    },
    mutations: {
        [T.SET_ARRANGEMENT_LIST](state, data) {
            state.list = (data && data.list) || []
            state.total = (data && data.count) || 0
        },
        [T.SET_RELATION_LIST](state, data) {
            state.relationList = data || []
        }
    },
    actions: {
        // 获取分页部署列表
        [T.GET_ARRANGEMENT_LIST](store, params) {
            return ARRANGEMENT.get(params)
        },
        // 获取部署列表
        [T.GET_ARRANGEMENT_LIST_ALL](store, params) {
            return ARRANGEMENT.getAll(params)
        },
        // 新增部署配置
        [T.ADD_ARRANGEMENT](store, params) {
            return ARRANGEMENT.add(params)
        },
        // 编辑部署配置
        [T.EDIT_ARRANGEMENT](store, params) {
            return ARRANGEMENT.edit(params)
        },
        // 删除部署配置
        [T.DELETE_ARRANGEMENT_RELATION](store, params) {
            return ARRANGEMENT.deleteRelation(params)
        },
        // 获取部署关联配置
        [T.GET_ARRANGEMENT_RELATION](store, params) {
            return ARRANGEMENT.getRelation(params)
        },
        // 新增部署关联配置
        [T.ADD_ARRANGEMENT_RELATION](store, params) {
            return ARRANGEMENT.addRelation(params)
        },
        // 编辑部署关联配置编辑
        [T.EDIT_ARRANGEMENT_RELATION](store, params) {
            return ARRANGEMENT.editRelation(params)
        },
        // 删除部署关联配置
        [T.DELETE_ARRANGEMENT](store, params) {
            return ARRANGEMENT.delete(params)
        },
        // 发布管理
        [T.GET_PUBLISH_STATUS](store, params) {
            return ARRANGEMENT.getPublishStatus(params)
        },
        [T.PUBLISH_ARRANGEMENT](store, params) {
            return ARRANGEMENT.publishArrangemnt(params)
        },
        [T.GET_ARRANGEMENT_HISTORY_LIST_TOTLAL](store, params) {
            return ARRANGEMENT.getArrangementHistoryListTotal(params)
        },
        [T.GET_ARRANGEMENT_HISTORY_LIST_SINGLE](store, params) {
            return ARRANGEMENT.getArrangementHistoryListSingle(params)
        },
        [T.GET_ARRANGEMENT_HISTORY_DETAIL](store, params) {
            return ARRANGEMENT.getArrangementHistoryDetail(params)
        }
    }
}

export default module
